<template>
    <AdmPanel>
        <h2 slot="header_title">历史得分</h2>
        <!-- <ul slot="tabs" class="adm-tabs">
            <router-link tag="li" active-class="active" :to="{name:`${isAudit?'audit_':''}result_ranking`}">排行榜</router-link>
            <router-link tag="li" active-class="active" :to="{name:`${isAudit?'audit_':''}result_firstTarge`}">一级指标得分</router-link>
        </ul> -->
        <!-- 导出 -->
        <!-- <iv-button
          v-if="isAudit"
          slot="header_buttons"
          type="primary"
          ghost
          @click="modal.release.shown=true"
        >
          <iv-icon type="md-checkbox-outline" size="14" />
          <span> 发布榜单结果</span>
        </iv-button> -->
        <FilterBar slot="header_buttons" :value="conditions" :condition="options.filter_rules" @search="changeQuery">
          <iv-form-item class="adm-buttons">
            <iv-button
                :disabled="loader[SCORERANK]"
                type="info"
                @click="changeQuery()"
            >
                <iv-icon type="md-search" size="14" style="vertical-align:text-bottom"/> 查询
            </iv-button>
            <iv-button
              v-rbac-allow="['csrScore','export']"
              class="export-excel-btn"
              :loading="loader[SCORERANK+'export']"
              @click="exportExcel()"
            >
              <iv-icon type="ios-cloud-download" size="14" />
              <span> 导出</span>
            </iv-button>
          </iv-form-item>
        </FilterBar>
        <iv-table
                class="adm-table"
                :columns="columns"
                :loading="loader[SCORERANK+'fetch']"
                :data="list.data">
        </iv-table>
        <template v-if="list.last_page > 1">
            <div slot="footer" class="pull-right">
                <iv-page
                        @on-change="pageChanged"
                        :current="list.current_page"
                        :page-size="10"
                        show-elevator
                        show-total
                        :total="list.total">
                </iv-page>
            </div>
        </template>
        <iv-modal
          :mask-closable="false"
          title="发布榜单结果"
          width="450"
          :closable="false"
          v-model="modal.release.shown"
          @on-cancel="modal.release.shown = false">
          <iv-form label-position="left" :label-width="80">
              <iv-form-item label="榜单项目年" prop="year">
                  <iv-select v-model="modal.release.data.year">
                    <iv-option
                      v-for="year in options.year"
                      :key="year.id"
                      :value="year.id"
                      >{{ year.title }}</iv-option>
                  </iv-select>
              </iv-form-item>
          </iv-form>
          <iv-alert show-icon>系统将发布上述项目年的已审核数据到外部展示平台，请认真确认数据无误后再进行发布操作</iv-alert>
          <iv-button type="text" size="large" slot="footer" @click="modal.release.shown = false;modal.release.data.year=conditions.year">取消</iv-button>
          <iv-button type="primary" size="large" slot="footer" @click="publish(modal.release.data.year)">发布</iv-button>
        </iv-modal>
    </AdmPanel>
</template>
<script>
import { RELEASE_TASKS,RELEASE_ADD_POLLING_TASK } from "@/stores/modules/release"
import { mapActions, mapGetters } from 'vuex';

import ModelMixin from "@/mixins/Model.mixin";
import StatusMixin from "@/mixins/Status.mixin";
import LoaderMixin from "@/mixins/Loader.mixin";

import contact from "@/utils/contact";
import { conditioner, defaultVal, unique, downloadByUrl, years, renderFilterBar } from '@/utils/';

import FilterBar from "@/components/FilterBar_X2";
import CheckedList from "@/components/CheckedList";

import ScorerankModel  from '@/models/ScorerankModel';
import IndustryModel from "@/models/IndustryModel";
import CompanyModel    from '@/models/CompanyModel'
import ReleaseModel    from '@/models/ReleaseModel'

const _years = years(2010).map(year=>({...year, title:year.name}))
const options = {
    statistics:[
      {id : '0', title: '全部数据'},
      {id : '1', title: '已审核且通过数据'},
    ]
}
const filter_rules = [
    // {name: 'statistics', type: "Select", options: options.statistics, title: '统计范围', default: "", placeholder: "统计范围",style: { width: "140px" }},
    { name: 'stockCodeList', type: 'Select', options: [], title: '公司', default: '', placeholder: '公司', filterable: true, clearable: true, style: { width: '150px' } },
    {name: 'year', type: "Select", options: _years, title: '年份', default: "", placeholder: "年份", clearable:true},
]
function columns(vm){
    return  [
        {
            title: "公司名称",
            key: "abbreviation",
            align: "center",
            minWidth: 100,
        },
        {
            title: "行业",
            key: "industry",
            align: "center",
            minWidth: 100
        },
        {
            title: "年份",
            key: "year",
            align: "center",
            minWidth: 100,
        },
        {
            title: "得分",
            key: "score",
            align: "center",
            minWidth: 100,
        },
    ]
}
const _conditioner = conditioner(
    {//ui到url
      limit           : {type: Number, default: 10},
      // industryList    : {type: val=>  JSON.stringify(val) , default: ()=>[]},
      // stockCodeList   : {type: val=>  JSON.stringify(val.map(item=>item.stockCode)) , default: ()=>[]},
      stockCodeList   : { type: val=> JSON.stringify([val]), default: '' },
      statistics      : {type: String , default: ''},
      year            : {type: String , default: ""},
      timestamp       : {type: val=>new Date().getTime(), default: ()=>new Date().getTime()}
    },
    {//url到ui
      limit           : {type: Number, default: 10},
      // industryList    : {type: val=>  JSON.parse(val) , default: ()=>[]},
      // stockCodeList   : {type: val=>  JSON.parse(val) , default: ()=>[]},
      stockCodeList   : { type: val=> val?JSON.parse(val).pop():"", default: '' },
      year            : {type: val=> !!val?Number(val):'' , default: ''},
      statistics      : {type: String , default: ''},
    }
)


const COMPANY = CompanyModel.ModelName;
const SCORERANK = ScorerankModel.ModelName
const INDUSTRY = IndustryModel.ModelName
const RELEASE = ReleaseModel.ModelName

export default {
        name: "public_sentiment",
        mixins:[
            LoaderMixin(COMPANY, SCORERANK, SCORERANK+'fetch', SCORERANK+'export', INDUSTRY, RELEASE),
            ModelMixin({
                contact,
                models:[
                    CompanyModel,
                    ScorerankModel,
                    IndustryModel,
                    ReleaseModel
                ]
            })
        ],
        data() {
            return {
                columns: columns(this),
                conditions: {
                  ..._conditioner.default(),
                  abbreviation: ""
                },
                SCORERANK,
                INDUSTRY,
                list: {
                    data: [],
                    last_page:0,
                    current_page:1
                },
                options: {
                    ...options,
                    companys: [],
                    filter_rules,
                    year: _years
                },
                secondTarget:'',
                industries:[],
                sources:{
                    loading:false,
                    companyFake:''
                },
                modal: {
                  release: {
                    shown: false,
                    data: {
                      year: ""
                    }
                  }
                }
            }
        },
        async mounted () {
            const { query, params } = this.$route
            let conditions = _conditioner.serialize({...query,...params}) //处理成支持UI的格式
            await this.refreshIndustry()
            const companys = await this.refreshCompanys()
            // conditions.stockCodeList = this.serializeCompany(conditions.stockCodeList)
            conditions.statistics =conditions.statistics ? conditions.statistics : (this.isAudit ? '1': '0')
            this.conditions = conditions
            renderFilterBar(this.options.filter_rules)('stockCodeList', companys)
            this.$nextTick(()=>{
                this.refresh(conditions)
            })
        },
        beforeRouteUpdate(to, from, next){
            this.$nextTick(async ()=>{
              const { query, params } = to
              let conditions = {
                ..._conditioner.default(),
                ..._conditioner.serialize({...query,...params}) //处理成支持UI的格式
              }
              this.refreshIndustry()
              // conditions.stockCodeList = this.serializeCompany(conditions.stockCodeList)
              conditions.statistics =conditions.statistics ? conditions.statistics : (this.isAudit ? '1': '0')
              this.conditions = conditions
              this.refresh()
            })
            next();
        },
        methods: {
            ...mapActions([RELEASE_ADD_POLLING_TASK]),
            async refresh(query=this.conditions){
                this.list = await this.$$fetch(SCORERANK , _conditioner.parse({ ...query, type:'scoreHistoryRank' }));
                this.list.current_page = _conditioner.parse(query).offset ? _conditioner.parse(query).offset / _conditioner.parse(query).limit + 1 : 1
                this.list.last_page = this.list.total / _conditioner.parse(query).limit
            },
            async refreshCompanys(industryList){
                const res = await this.$$fetch(COMPANY, {industryList : JSON.stringify(industryList), limit: 9999, allTab: 1})
                return this.options.companys = res.data.map(item => ({ id: item.stockCode, name: item.abbreviation }))
            },
            async refreshIndustry(params = this.$route.params){
                const industry = await this.$$fetch(INDUSTRY, params)
                this.industries = industry.data.map(item=>({...item, title: item.industry }))
            },
            onCompanyChanged(stockCode){
              this.sources.companyFake = ""
              this.$refs.companySelection.clearSingleSelect()
              const company = this.options.companys.find(item=>item.stockCode == stockCode)
              // if(company) this.conditions.stockCodeList = unique([...this.conditions.stockCodeList, company], 'stockCode')
              if(company) this.changeQuery(this.mergeQuery({ stockCodeList:[...unique([...this.conditions.stockCodeList, company], 'stockCode')], offset:0 }))
            },
            Search(val){
                if(!val) this.conditions.industryList = []
                else{
                    if(this.conditions.industryList.indexOf(val.id) > -1)
                        this.conditions.industryList.splice(this.conditions.industryList.indexOf(val.id),1)
                    else
                        this.conditions.industryList.push(val.id)
                }
                this.changeQuery()
            },
            pageChanged(page){
                this.$router.push({ name: this.$route.name, query: { ...this.$route.query, offset: ( page - 1 ) *  _conditioner.parse(this.conditions).limit}, params: this.$route.params });
            },
            mergeQuery(query){
              return { ...this.conditions, ...query}
            },
            changeQuery(query=this.conditions, params = this.$route.params) {
                this.$router.push({
                    name  : this.$route.name,
                    query: {..._conditioner.parse(query)},
                    params: params
                });
            },
            removeConditioner(fieldName, removeItem, keyField="id"){

              const list = [...this.conditions[fieldName]]
              const index = list.findIndex(item=>item[keyField]==removeItem[keyField])
              list.splice(index,1)
              this.changeQuery(this.mergeQuery({ [fieldName]: list, offset:0 }))
            },
            parseQuery(params, filter=[]){
              const { company } = { ...params }
              const query = {
                stockCodeList: company.map(item=>item.stockCode),
              }
              return Object.keys(query).filter(key=>filter.indexOf(key)).reduce((result, key)=>({ ...result, [key]:query[key] }),{})
            },
            async exportExcel(query = this.conditions) {
              // console.log({..._conditioner.parse(query)})
              // const res = await exportReportExcel({..._conditioner.parse(query)})
              const res = await this.$$active(SCORERANK, 'export',{..._conditioner.parse({ ...query, type: 'scoreHistoryRank' })})
              console.log("exportExcel...", res)
              if(!res.data.url) {
                this.$$info('后台未返回url，请重试')
                return
              }
              // 下载链接
              downloadByUrl(res.data.url)
            },
            serializeCompany(ids, companys=this.options.companys){
              return companys.filter(item=>ids.indexOf(item.stockCode)>-1)
            },
            publish(year){
              this
                .$$active(RELEASE, 'publish', { type: 'csr', year })
                .then(res=>{
                  const { id } = res.data
                  this[RELEASE_ADD_POLLING_TASK]({id, group:this.$route.name})
                  this.modal.release.shown = false
                })
            }
        },
        watch:{
            // async ['conditions.stockCodeList'](company){
            //     this.sources.loading = true
            //     await this.refresh(this.parseQuery({ company }))
            //     this.$nextTick(()=>this.sources.loading = false)
            // },
            // async ['conditions.industryList'](val){
            //     this.conditions.stockCodeList = []
            //     await this.refreshCompanys(val)
            //     await this.refresh()
            // }
            ["conditions.year"](val){
              this.modal.release.data.year=val
            }
        },
        computed: {
          ...mapGetters([RELEASE_TASKS]),
          isAudit(){
            return this.$route.matched.some(item=>item.name=='audit')
          }
        },
        components:{
            FilterBar,
            CheckedList
        }
    }
</script>
<style lang="scss" scoped>
.checked-list{
  // margin-top:20px;
  display:flex;
  align-items: baseline;
  @media screen and (min-width: 768px) {
    display: flex;
  }
  &__title{
    flex-shrink: 0;
    margin-right: 5px;
    margin-bottom: 10px;
    display: block;
    @media screen and (min-width: 768px) {
      text-align: right;
    }
  }
  &__body{
    flex-grow: 1;
    > * {
      margin-bottom: 5px;
    }
  }
}
.filter-wrapper {
  position: relative;
  .export-excel-btn {
    position: absolute;
    right: 0;
    top: 0;
  }
}
</style>
